// Shared Inventory constants + helpers.

export const INV_CATEGORIES = [
  "cleaning",
  "safety",
  "maintenance",
  "office",
  "kitchen",
  "other",
] as const;

// Lifecycle status offered in the UI. The D1 CHECK also permits "inactive",
// but the app keeps it simple: an item is either Active or Archived.
export const INV_STATUSES = ["active", "archived"] as const;
export const INV_DELIVERY_STATUSES = ["in_stock", "ordered", "not_delivered"] as const;
export const INV_SUPPLIERS = ["Home Depot", "RONA", "Amazon Business", "Costco", "Local supplier"] as const;

export function invCategoryLabel(c: string | null): string {
  if (!c) return "—";
  return c.charAt(0).toUpperCase() + c.slice(1);
}

export function invStatusLabel(s: string): string {
  return { active: "Active", inactive: "Inactive", archived: "Archived" }[s] ?? s;
}

export function invDeliveryStatusLabel(s: string): string {
  return { in_stock: "In stock", ordered: "Ordered", not_delivered: "Not delivered" }[s] ?? s;
}

// Low stock = at or below the reorder threshold (when a threshold is set).
export function isLowStock(quantity: number, reorderThreshold: number | null): boolean {
  return reorderThreshold != null && quantity <= reorderThreshold;
}

export function formatQuantity(quantity: number, unit: string | null): string {
  return unit ? `${quantity} ${unit}` : String(quantity);
}
